import { Flex, Text } from '@chakra-ui/react';
import { memo } from 'react';

import { UserMessageProps } from '../Chat.types';

/**
 * Render the user message in the ChatPanel
 *
 * @param data.messages[0] The user input text to be displayed
 */
export const UserMessage = memo(({ data }: UserMessageProps) => {
  const ChatUserMessageTestId = 'chat-user-message';
  return (
    <Flex justifyContent='flex-end' data-testid={ChatUserMessageTestId}>
      <Text p='2' borderRadius='lg' bg='gray.50' textAlign='right'>
        {data.messages[0]}
      </Text>
    </Flex>
  );
});

UserMessage.displayName = 'UserMessage';
